var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"py-10 py-md-13 py-lg-16"},[_c('TitleWidget',[_vm._v("Política de Privacidade")]),_c('PolicyPrivacyWidget',{staticClass:"primary--text text--lighten-1 mt-4 mt-md-6"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }